import { render, staticRenderFns } from "./dashboard-resources.vue?vue&type=template&id=668842af&scoped=true&"
import script from "./dashboard-resources.vue?vue&type=script&lang=js&"
export * from "./dashboard-resources.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-resources.vue?vue&type=style&index=0&id=668842af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668842af",
  null
  
)

export default component.exports